import styled from 'styled-components';
import {tokens} from "../../../../../theme";

export const DocumentsDigitizationFooterWrapper = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding: 0 32px 8px;
    border-top: 1px solid #E2E8F0;
    flex-wrap: wrap;
    gap: 12px;
`;

export const FooterLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const FooterRight = styled.div`
    display: flex;
    align-items: center;
`;

export const StyledPageSizeLabel = styled.p`
    padding: 6px;
    font-size: ${tokens.fontSize.base};
`;